export function getCountryName(countryCode) {
    const countryNames = {
        'CR': "Costa Rica",
        'MX': "México",
        'US': "Estados Unidos",
        'ES': "España",
    };
    
    return countryNames[countryCode] || "Desconocido";
}